﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import DIWViewport from '@/basics/diw.viewport';
import DIWDialog from '@/components/diw.dialog';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKFileUploadArea from '@tk/controls/tk.file.upload.area';
import TKFileLink from '@tk/components/tk.file.link';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFilter from '@tk/components/tk.filter';
import TKFilterChip from '@tk/components/tk.filter.chip';
import TKFilterDrilldownButton from '@tk/components/tk.filter.drilldown.button';
import TKFilterDropdown from '@tk/components/tk.filter.dropdown';
import TKFilterGroup from '@tk/components/tk.filter.group';
import TKFilterGroupWrapper from '@tk/components/tk.filter.group.wrapper';
import TKFilterResult from '@tk/components/tk.filter.result';
import TKFilterSearch from '@tk/components/tk.filter.search';
import TKFilterSelectReset from '@tk/components/tk.filter.select.reset';
import TKFormRangeslider from '@tk/controls/tk.form.rangeslider';
import DIWMap from '@/components/diw.map';
import DIWMapForm from '@/components/diw.map.form';
import DIWFormRangeslider from '@/controls/diw.form.rangeslider';
import DIWCarousel from '@/components/diw.carousel';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import DIWMinibasket from '@/components/diw.minibasket';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import { configureStore } from '@tk/utilities/tk.use.store';
import DIWSearch from '@/controls/diw.search';
import DIWButtonDropdown from '@/controls/diw.button.dropdown';
import CMSVideoEmbed from '@cms/ts/components/cms.video.embed';
import DIWHeadingNav from '@/components/diw.heading.nav';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';

import '@uppy/dashboard/dist/style.min.css';
import '@uppy/core/dist/style.min.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import '@scss/modules/staticcontent.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Staticcontent extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-file-upload-area', constructor: TKFileUploadArea },
            { name: 'tk-file-link', constructor: TKFileLink },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'diw-map', constructor: DIWMap },
            { name: 'diw-map-form', constructor: DIWMapForm },
            { name: 'tk-filter', constructor: TKFilter },
            { name: 'tk-filter-chip', constructor: TKFilterChip },
            { name: 'tk-filter-result', constructor: TKFilterResult },
            { name: 'tk-filter-dropdown', constructor: TKFilterDropdown },
            { name: 'tk-filter-group-wrapper', constructor: TKFilterGroupWrapper },
            { name: 'tk-filter-group', constructor: TKFilterGroup },
            { name: 'tk-filter-search', constructor: TKFilterSearch },
            { name: 'tk-filter-select-reset', constructor: TKFilterSelectReset },
            { name: 'tk-filter-drilldown-button', constructor: TKFilterDrilldownButton },
            { name: 'tk-form-range-slider', constructor: TKFormRangeslider },
            { name: 'diw-form-range-slider', constructor: DIWFormRangeslider },
            { name: 'tk-carousel', constructor: DIWCarousel },
            { name: 'tk-compare-info', constructor: TKCompareInfo },
            { name: 'diw-minibasket', constructor: DIWMinibasket },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'diw-search', constructor: DIWSearch },
            { name: 'tk-button-dropdown', constructor: DIWButtonDropdown },
            { name: 'cms-video-embed', constructor: CMSVideoEmbed },
            { name: 'tk-heading-nav', constructor: DIWHeadingNav },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
        ]);
    }
}

new Staticcontent();
